import React, { useEffect, useState } from "react"
import classnames from "classnames"
import { useAppDispatch, useAppSelector } from "../../state/hooks"
import { setContactOpen } from "../../state/menus"
import "./styles.scss"

const ContactForm: React.FC = () => {
  const [isContactDOMOpen, setisContactDOMOpen] = useState(false)
  const [contact, setContact] = useState({
    phone: "",
    email: "",
  })
  const [isShowingThankYou, setShowingThankYou] = useState(false)

  const dispatch = useAppDispatch()
  const isContactOpen = useAppSelector(state => state.menus.isContactOpen)

  useEffect(() => {
    let cartTimeout

    if (isContactOpen) {
      cartTimeout = setTimeout(() => {
        setisContactDOMOpen(true)
      }, 300)
    } else {
      setisContactDOMOpen(false)
    }

    return () => {
      clearTimeout(cartTimeout)
    }
  }, [isContactOpen])

  const submitForm = () => {
    if (typeof window !== "undefined") {
      // @ts-ignore
      window.fbq("track", "Contact")
    }
    fetch(
      "https://docs.google.com/forms/d/e/1FAIpQLSd3bUJiEr-g72-ywuFiDH2HtWXN8-GNhfoBftNJDDX_EbLIVg/formResponse",
      {
        headers: {
          accept:
            "text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9",
          "accept-language": "en-US,en;q=0.9",
          "cache-control": "max-age=0",
          "content-type": "application/x-www-form-urlencoded",
          "sec-ch-ua":
            '"Chromium";v="92", " Not A;Brand";v="99", "Google Chrome";v="92"',
          "sec-ch-ua-mobile": "?0",
          "sec-fetch-dest": "document",
          "sec-fetch-mode": "navigate",
          "sec-fetch-site": "same-origin",
          "sec-fetch-user": "?1",
          "upgrade-insecure-requests": "1",
        },
        referrer:
          "https://docs.google.com/forms/d/e/1FAIpQLSd3bUJiEr-g72-ywuFiDH2HtWXN8-GNhfoBftNJDDX_EbLIVg/viewform?fbzx=-3484751751395537660",
        referrerPolicy: "strict-origin-when-cross-origin",
        body: `entry.268637486=${encodeURIComponent(
          contact.email
        )}&entry.1707983108=${encodeURIComponent(
          contact.phone
        )}&fvv=1&draftResponse=%5Bnull%2Cnull%2C%22-3484751751395537660%22%5D&pageHistory=0&fbzx=-3484751751395537660`,
        method: "POST",
        mode: "no-cors",
        credentials: "include",
      }
    ).then(() => {
      setContact({
        email: "",
        phone: "",
      })
      setShowingThankYou(true)
    })
  }
  const handleKeyUp = (evt: React.KeyboardEvent<HTMLInputElement>): void => {
    if (evt.key === "Enter") {
      submitForm()
    }
  }
  return (
    <>
      <div
        className={classnames(
          "contact-scrim hidden fixed h-full w-full z-40 md:block",
          {
            "pointer-events-none": !isContactDOMOpen,
            "is-visible": isContactDOMOpen,
          }
        )}
        onClick={() => dispatch(setContactOpen(false))}
      />
      <div
        className={classnames(
          "contact-overlay w-full h-full z-50 top-0 left-0 md:w-6/12 md:right-0 md:left-auto md:ml-6/12 md:pt-14 md:flex md:flex-col",
          {
            "is-closed": !isContactDOMOpen,
          }
        )}
      >
        <div className="fixed top-0 w-full h-screen bg-black md:hidden"></div>

        <div className="flex flex-col h-full bg-black md:border-t md:border-white md:overflow-scroll">
          <div className="relative sticky top-0 z-20 w-full py-6 text-center bg-black">
            <button
              className="absolute flex items-center w-16 h-16 transform left-4 top-2/4 -translate-y-2/4"
              onClick={() => dispatch(setContactOpen(false))}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="z-20 pt-10 text-center">
            {isShowingThankYou ? (
              <div>
                THANK YOU
                <br />
                <br />
                YOUR SATISIFACTION IS OUR PRIORTIY
                <br />
                <br />
                WE WILL BE IN TOUCH
                <br />
                <br />
                <a className="underline" href="tel:+19174569461">
                  +1 917-456-9461
                </a>
                <br />
                <br />
                <a className="underline" href="mailto:orders@uniformobject.com">
                  orders@uniformobject.com
                </a>
                <div className="px-2 mt-6">
                  <button
                    onClick={() => {
                      setShowingThankYou(false)
                    }}
                    className="w-full py-4 uppercase border"
                  >
                    Back to contact form
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div>
                  <p className="uppercase">Enter your number below</p>

                  <div className="px-2 mt-6">
                    <input
                      type="phone"
                      value={contact.phone}
                      onKeyUp={handleKeyUp}
                      onChange={evt =>
                        setContact({
                          ...contact,
                          phone: evt.currentTarget.value,
                        })
                      }
                      className="box-border w-full text-xl text-center bg-black border-b border-solid"
                    ></input>
                  </div>

                  <div className="px-2 mt-6">
                    <button
                      onClick={submitForm}
                      className="w-full py-4 uppercase border"
                    >
                      Text Us
                    </button>
                  </div>
                </div>
                <div className="mt-16">
                  <p className="uppercase">Enter your email below</p>

                  <div className="px-2 mt-6">
                    <input
                      type="email"
                      value={contact.email}
                      onKeyUp={handleKeyUp}
                      onChange={evt =>
                        setContact({
                          ...contact,
                          email: evt.currentTarget.value,
                        })
                      }
                      className="box-border w-full text-xl text-center bg-black border-b border-solid"
                    ></input>
                  </div>

                  <div className="px-2 mt-6">
                    <button
                      onClick={submitForm}
                      className="w-full py-4 uppercase border"
                    >
                      Email Us
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ContactForm
